import { authHeader } from '../helpers';
import { bake_cookie, delete_cookie, userCookie } from '../helpers/cookieHelper';

export const userService = {
	login,
	logout,
	getAll
}

function login(username, password) {
		const formdata = new FormData();
		formdata.append('id', username);
		formdata.append('pwd', password);
    const requestOptions = {
        method: 'POST',
        body: formdata,
				mode: "cors",
				headers: {}
    };
    return fetch(
    	`v5/public/login`, requestOptions
    	)
        .then(handleResponse => handleResponse.json())
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user.profile.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                var expireTime = new Date(new Date().getTime() + 8 * 60 * 60 * 1000);
                bake_cookie(userCookie, user.profile,expireTime);
                //  localStorage.setItem('user', JSON.stringify(user));
            }

            return user;
        });
}

function logout() {
    // remove user from local storage to log user out
    // localStorage.removeItem('user');
    delete_cookie(userCookie);
    console.log('log out!');
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(
    	`http://localhost:3000/loginSucess`
    	, requestOptions)

    	.then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                window.location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}



// WEBPACK FOOTER //
// ./src/loginService/user.service.js